import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerHero, getHeroList } from '../../api/senaApi';
import { heroPortrait, skillImg, addUploadedHero } from './senaAssets';
import './SenaAuth.css';

// 영웅 도감 개요 화면 캡쳐 1장으로 신규 영웅을 등록한다 (ADMIN 전용).
// 스킬 개수는 서버가 캡쳐의 아이콘 개수로 판정하므로 입력받지 않는다.
export default function SenaHeroRegister() {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole');

  const [heroNm, setHeroNm] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(null);   // 등록 완료된 영웅 (결과 이미지 확인용)
  const [heroNames, setHeroNames] = useState([]);

  useEffect(() => {
    if (userRole !== 'ADMIN') {
      alert('관리자만 접근 가능합니다.');
      navigate('/sena');
      return;
    }
    getHeroList('ALLY')
      .then(r => setHeroNames((r.data || []).map(h => h.heroNm)))
      .catch(() => setHeroNames([]));
  }, []);

  const handleFile = (e) => {
    const f = e.target.files?.[0] || null;
    setFile(f);
    setError('');
    setPreview(f ? URL.createObjectURL(f) : null);
  };

  const handleSubmit = () => {
    const name = heroNm.trim();
    if (!name) { setError('영웅 이름을 입력해주세요.'); return; }
    if (!/^[가-힣A-Za-z0-9]{1,30}$/.test(name)) {
      setError('영웅 이름은 한글/영문/숫자 1~30자만 가능합니다.'); return;
    }
    if (heroNames.includes(name)) { setError(`이미 등록된 영웅입니다: ${name}`); return; }
    if (!file) { setError('영웅 도감 캡쳐를 선택해주세요.'); return; }

    setSaving(true);
    setError('');
    registerHero(name, file)
      .then(r => {
        addUploadedHero(name);   // 결과 카드·공략 화면에서 바로 이미지가 뜨도록
        setDone(r.data);
        setHeroNames(prev => [...prev, name]);
        setHeroNm('');
        setFile(null);
        setPreview(null);
      })
      .catch(e => setError(typeof e?.response?.data === 'string'
        ? e.response.data : '등록에 실패했습니다.'))
      .finally(() => setSaving(false));
  };

  const doneNm = done?.hero?.heroNm;
  const doneSkills = done?.hero?.skills || [];

  return (
    <div className="sena-page">
      <header className="sena-header">
        <button className="siege-back-btn" onClick={() => navigate('/sena')}>← 메인으로</button>
        <h1 className="sena-header-guild">영웅 등록</h1>
        <p className="sena-header-sub">영웅 도감 '개요' 화면 캡쳐 1장으로 등록</p>
      </header>

      <div className="sena-admin-container">
        <div className="sena-auth-card" style={{ maxWidth: 560, margin: '0 auto' }}>
          <div className="sena-auth-form">
            <div className="sena-auth-field">
              <label>영웅 이름</label>
              <input type="text" value={heroNm} placeholder="게임 내 표기 그대로 (예: 동영)"
                onChange={e => { setHeroNm(e.target.value); setError(''); }} />
            </div>

            <div className="sena-auth-field">
              <label>영웅 도감 캡쳐 (2778 x 1284)</label>
              <input type="file" accept="image/png,image/jpeg" onChange={handleFile} />
              <p style={{ fontSize: 12, color: '#c88050', margin: '6px 0 0' }}>
                초상화·스킬 아이콘은 서버가 캡쳐에서 잘라냅니다.
                스킬 개수(1개 / 2개 / 각성 3개)도 자동 판정됩니다.
              </p>
            </div>

            {preview && (
              <img src={preview} alt="캡쳐 미리보기"
                style={{ width: '100%', borderRadius: 8, border: '2px solid #f0d6c0' }} />
            )}

            {error && <p className="sena-auth-error">{error}</p>}

            <button className="sena-auth-btn" onClick={handleSubmit} disabled={saving}>
              {saving ? '등록 중...' : '등록'}
            </button>
          </div>
        </div>

        {done && (
          <div className="sena-auth-card" style={{ maxWidth: 560, margin: '16px auto 0' }}>
            <h2 className="sena-auth-title" style={{ fontSize: 20 }}>{doneNm} 등록 완료</h2>
            <p className="sena-auth-sub">
              아이콘 {done.iconCount}개 판정 → 스킬 {doneSkills.length}개
            </p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center', alignItems: 'center' }}>
              {heroPortrait(doneNm, 'ALLY') && (
                <img src={heroPortrait(doneNm, 'ALLY')} alt="초상화"
                  style={{ width: 92, borderRadius: 8 }} />
              )}
              {doneSkills.map(s => {
                const img = skillImg(doneNm, 'ALLY', s.skillNo);
                return img
                  ? <img key={s.skillNo} src={img} alt={`스킬${s.skillNo}`}
                      style={{ width: 52, borderRadius: 8 }} />
                  : <span key={s.skillNo}>스킬{s.skillNo}</span>;
              })}
            </div>
            <p className="sena-auth-sub" style={{ marginTop: 12 }}>
              공략 작성 화면에서 바로 검색·사용할 수 있습니다.
            </p>
          </div>
        )}

        <p className="sena-admin-empty" style={{ marginTop: 20 }}>
          등록된 아군 영웅 {heroNames.length}명
        </p>
      </div>
    </div>
  );
}
